import { render, staticRenderFns } from "./parking-items.vue?vue&type=template&id=58984519"
import script from "./parking-items.vue?vue&type=script&lang=js"
export * from "./parking-items.vue?vue&type=script&lang=js"
import style0 from "./parking-items.vue?vue&type=style&index=0&id=58984519&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports